module.exports = __webpack_public_path__ + "img/public_resources_voice_mute.de3d0fd6.svg";